import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddProductRequest } from '../models/request/product/AddProductRequest';
import { GetProductListPagingAndFilterRequest } from '../models/request/product/GetProductListPagingAndFilterRequest';

export class ProductService {
    static async getProductList(_isSubProduct: boolean | undefined = undefined) {
        try {
            var inputObj = {
                isSubProduct: _isSubProduct
            };

            console.log('SERVICE CALL - getProductList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Product/getProductList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportProductList(inputObj: GetProductListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportProductList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Product/exportProductList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getProductListPagingAndFilter(inputObj: GetProductListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetProductListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Product/GetProductListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addProduct(inputObj: AddProductRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddProduct', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Product/AddProduct', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteProduct(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteProduct', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Product/deleteProduct', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getProductById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getProductById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Product/getProductById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }
}